import { TextField, MenuItem } from "@material-ui/core";
import MaterialIcon from "material-icons-react";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
// import NumberFormat from "react-number-format";
import Drawer from "../../../../../components/Drawer";
import TextPhoneMask from "../../../../../components/Mask/TextPhoneMask";
import xIconBlack from "../../../../../assets/img/x-icon-black.svg";
import addBlue from "../../../../../assets/img/add-blue.svg";
import scissors from "../../../../../assets/img/scissors.svg";
import api from "../../../../../config/api";
import { useAuth } from "../../../../../context/ContextApi";
import SelectService from "../components/SelectService";
import SelectHours from "../../../../../components/SelectHours/SelectHours";
import ActiveCollaboratorAvailableHours from "./ActiveCollaboratorAvailableHours";
import "../BeautyReserve.scss";
import CircleImage from "../../../../../components/Image/CircleImage";
import SelectCollaborator from "./SelectCollaborator";
import swal from "sweetalert";
import { Panel, PanelGroup } from "rsuite";
import TextFieldMultiLine from "@mui/material/TextField";

const NewBeautyReserveDrawer = ({
  isAddBeautyReserveDrawerOpen,
  setShowProduct,
  showProduct,
  setIsAddBeautyReserveDrawerOpen,
  loadBtn,
  setReserve,
  reserve,
  initialReserve,
  handleNewReserve,
  createBeautyReservation,
}) => {
  const newService = {
    products: "",
    qty: 1,
    professional: "",
    date: "",
    hour: "",
    description: "",
  };

  const [services, setServices] = useState(reserve.serviceList);
  const [products, setProductsList] = useState([]);
  const [totalValueArraySet, setTotalValueArray] = useState([]);
  const [totalValue, setTotalValue] = useState("");
  const [name, setName] = useState("");
  const [userId, setUserId] = useState("");
  const [email, setEmail] = useState("");
  const [activeCollaborator, setActiveCollaborator] = useState("");
  const [error, setError] = useState("");
  const [errorService, setErrorService] = useState("");
  const [dateSelected, setDateSelected] = useState("");
  const { userEstablishment, service, getTypes } = useAuth();

  const [availableProfessionals, setAvailableProfessionals] = useState();
  const validation = (e) => {
    e.preventDefault();
    let error = false;
    let errorService = false;
    if (!reserve.tel || !reserve.client) {
      error = true;
      return swal("Campo não preenchido", "Verifique os dados enviados", "error");
    }
    if (!reserve.serviceList[0].products) {
      errorService = true;
      setErrorService(true);
      return swal("Serviço não adicionado", "Verifique os dados enviados", "error");
    }
    reserve.serviceList.map((service) => {
      console.log(!service.date, !service.hour.length, !service.products);
      if (!service.date || !service.hour || !service.products) {
        setErrorService(true);
        errorService = true;
      }
      console.log("aqui", service.date && service.hour.length && service.products);
      if (service.date && service.hour.length && service.products) {
        setErrorService(false);
        errorService = false;
      }
    });
    if (errorService) {
      return swal("Serviço não adicionado", "Verifique os dados enviados", "error");
    } else {
      error = false;
      setError(false);
      errorService = false;
      setErrorService(false);
    }
    if (!error && !errorService) {
      createBeautyReservation().then(() => {
        clear();
        setError(false);
        setErrorService(false);
      });
    }
  };

  const getServices = async () => {
    const response = await api.get(`/product/?type=${service}&establishment=${userEstablishment}`);
    setProductsList(response.data);
  };

  const handleServiceChange = (event, index) => {
    let serviceChanged = reserve.serviceList[index];
    let serviceState = services;
    for (const key in serviceChanged) {
      if (key === event.target.name) {
        serviceChanged[event.target.name] = event.target.value;
      }
    }
    reserve.serviceList[index] = serviceChanged;
    serviceState[index] = serviceChanged;
    setServices([...serviceState]);
  };

  const handlePhoneChange = async (event) => {
    if (!event.target.value) return;
    const phoneValue = event.target.value.replace(/\s/g, "");
    const response = await api.get(`/dashboard-verify-user/?phone=${phoneValue}`);
    if (response.data.user) {
      setName(() => response.data.user.name);
      setUserId(() => response.data.user._id);
      setEmail(() => response.data.user.email);
    } else {
      setName(() => "");
      setEmail(() => "");
      setUserId(() => "");
    }
  };

  const save = () => {
    reserve.client = name;
    reserve.email = email;
    reserve.userId = userId;
  };

  const handleTotalValueChange = (serviceState, index) => {
    let totalValueArray = totalValueArraySet;
    totalValueArray.splice(index, 1, serviceState.price);
    let total = 0;
    setTotalValueArray(() => totalValueArray);
    totalValueArray.map((value) => {
      total += parseFloat(value);
    });
    setTotalValue(() => total);
    reserve.totalValue = total;
  };

  const addNewService = () => {
    setServices([...services, newService]);
    reserve.serviceList = [...services, newService];
  };

  const removeService = (index) => {
    let serviceListRemove = services;
    serviceListRemove.splice(index, 1);
    setServices([...serviceListRemove]);
    reserve.serviceList = [...serviceListRemove];
  };

  useEffect(() => {
    getServices();
  }, [service, userEstablishment]);

  const clear = (e) => {
    setReserve(initialReserve);
    setName("");
    setEmail("");
    setServices([]);
    setTotalValue("");
  };
  const handleCloseNewBeautyReserveDrawer = () => {
    clear();
    setIsAddBeautyReserveDrawerOpen(false);
  };

  return (
    <Drawer
      show={isAddBeautyReserveDrawerOpen}
      onClose={() => {
        handleCloseNewBeautyReserveDrawer();
      }}
    >
      <form style={{ maxHeight: "100%" }}>
        <div className="d-flex col align-items-center">
          <span className="text-cl-black ff-univanova-medium fz-20 mb-4 me-auto">Adicionar Reserva</span>
        </div>
        <div className="d-flex flex-column">
          <TextField
            required
            label={"Telefone"}
            variant={"outlined"}
            name={"tel"}
            InputProps={{
              inputComponent: TextPhoneMask,
            }}
            onChange={(e) => {
              handleNewReserve(e);
              handlePhoneChange(e);
            }}
            error={error}
            onBlur={() => save()}
            value={reserve?.tel}
            className="fz-16 text-cl-dark-jungle-green ff-univanova mb-4"
          />
          <TextField
            required
            label={"Cliente"}
            name={"client"}
            variant={"outlined"}
            onChange={(e) => {
              handleNewReserve(e);
              setName(e.target.value);
            }}
            error={error}
            value={name}
            className="fz-16 text-cl-dark-jungle-green ff-univanova mb-4"
          />
          <TextField
            required
            label={"E-mail"}
            name={"email"}
            variant={"outlined"}
            onChange={(e) => {
              handleNewReserve(e);
              setEmail(e.target.value);
            }}
            error={error}
            type={"email"}
            value={email}
            className="fz-16 text-cl-dark-jungle-green ff-univanova mb-4"
          />

          <span className="text-cl-black ff-univanova-medium fz-20 mt-3 mb-4 me-auto">Serviços</span>

          {reserve?.serviceList?.length ? (
            <>
              {reserve.serviceList.map((service, index) => (
                <>
                  <PanelGroup accordion className="mt-1">
                    <Panel
                      defaultExpanded
                      bodyFill={false}
                      className={` bg-cl-azure text-white ff-univanova-600 fz-16 `}
                      header={
                        <div className="text-white ff-univanova-600 fz-16 d-flex align-items-center">
                          <span>Serviço {index + 1}</span>
                          <div className="d-flex align-items-center ms-auto">
                            <MaterialIcon color="white" icon="expand_more" />
                          </div>
                        </div>
                      }
                      eventKey={service?._id}
                      id={service?._id}
                    >
                      <div
                        className="d-flex flex-column p-3 px-4 pt-4  bg-white"
                        style={{ border: "1px solid #D9D9D9" }}
                      >
                        <SelectService
                          userEstablishment={userEstablishment}
                          options={products}
                          handleServiceChange={handleServiceChange}
                          index={index}
                          reserve={reserve.serviceList[index]}
                          handleTotalValueChange={handleTotalValueChange}
                          setAvailableProfessionals={setAvailableProfessionals}
                          errorService={errorService}
                        />

                        <TextField
                          required
                          label={"Data"}
                          type={"date"}
                          variant={"outlined"}
                          name={"date"}
                          error={errorService}
                          value={service?.date}
                          onChange={(e) => {
                            handleServiceChange(e, index);
                            setDateSelected(e.target.value);
                          }}
                          InputLabelProps={{ shrink: true }}
                          className="fz-16 text-cl-dark-jungle-green ff-univanova mb-3"
                        />
                        {service?.products && !service?.date ? (
                          <span className="text-cl-red ff-univanova-medium fz-12 me-auto"> *Escolha uma data</span>
                        ) : (
                          <></>
                        )}
                        <span className="text-cl-black ff-univanova-medium fz-16 mt-3 me-auto mb-3">
                          Colaboradores disponíveis
                        </span>
                        <div className="d-flex scroll-collaborators collaborators text-cl-auroMetal fz-12 mb-3">
                          {availableProfessionals?.length && service.date ? (
                            <>
                              {availableProfessionals.map((collaborator) => (
                                <>
                                  <SelectCollaborator
                                    selectedCollaborator={service.professional}
                                    collaborator={collaborator}
                                    handleServiceChange={handleServiceChange}
                                    index={index}
                                  />
                                </>
                              ))}
                            </>
                          ) : (
                            <>
                              <div className="border-top border-bottom p-3 d-flex mt-4 col-12 justify-content-center">
                                <span className="text-cl-auroMetal ff-univanova-medium fz-16 ">
                                  Nenhum colaborador encontrado para esse serviço
                                </span>
                              </div>
                            </>
                          )}
                        </div>
                        <ActiveCollaboratorAvailableHours
                          reserveService={reserve.serviceList}
                          hourSelect={service?.hour}
                          serviceDuration={service?.products?.duration}
                          handleServiceChange={handleServiceChange}
                          activeCollaborator={service.professional}
                          dateSelected={service.date}
                          userEstablishment={userEstablishment}
                          index={index}
                        />
                        <TextFieldMultiLine
                          label={"Observação Geral"}
                          variant={"outlined"}
                          name={"description"}
                          error={error}
                          value={service?.description}
                          onChange={(e) => {
                            handleServiceChange(e, index);
                          }}
                          minRows={3}
                          multiline
                          className="fz-16 text-cl-dark-jungle-green ff-univanova mt-2 mb-3"
                        />
                        <div className={`col-12 col-lg d-flex justify-content-end`}>
                          <span
                            onClick={() => removeService(index)}
                            className="bg-transparent border-0 rounded-2 fz-16 d-flex c-pointer justify-content-center text-cl-red align-items-center ff-univanova-medium py-2"
                          >
                            Remover serviço
                          </span>
                        </div>
                      </div>
                    </Panel>
                  </PanelGroup>
                </>
              ))}
            </>
          ) : (
            <></>
          )}

          <div className={`col-12 col-lg d-flex justify-content-end`}>
            <span
              onClick={() => {
                addNewService();
              }}
              className="bg-transparent border-0 rounded-2 fz-16 d-flex c-pointer justify-content-center text-cl-azure align-items-center ff-univanova-medium py-2 "
            >
              <img className="me-1 d-flex align-items-center" alt="" src={addBlue} width={22} height={22} /> Adicionar
              novo serviço
            </span>
          </div>

          <div className="border-top border-bottom p-3 px-0 d-flex my-4">
            <span className="text-cl-black ff-univanova-medium fz-20 d-block justify-content-start me-auto">
              Valor Total
            </span>
            <span className="text-cl-forest-green ff-univanova-medium fz-20 d-block justify-content-end">
              R$ {parseFloat(totalValue).toFixed(2) === "NaN" ? "--,--" : parseFloat(totalValue).toFixed(2)}
            </span>
          </div>
        </div>
        <div className={`col-12 col-lg d-flex justify-content-end`}>
          <button
            onClick={(e) => {
              setIsAddBeautyReserveDrawerOpen(false);
              clear(e);
            }}
            className="bg-transparent border-1 me-4 rounded-2 fz-14 d-flex justify-content-center align-items-center ff-univanova-medium py-2 px-4 botton-cancel"
          >
            Cancelar
          </button>
          {loadBtn ? (
            <div className="btn br-6 bg-gradient-theme-blue text-white px-4 d-flex align-items-center justify-content-center">
              <Spinner animation="border" role="status" style={{ height: 20, width: 20 }} className="mx-2" />
            </div>
          ) : (
            <button
              disabled={loadBtn}
              onClick={(e) => validation(e)}
              className="btn br-6 bg-gradient-theme-blue text-white px-4"
            >
              Salvar
            </button>
          )}
        </div>
      </form>
    </Drawer>
  );
};

export default NewBeautyReserveDrawer;
